import React from "react";
import {Row, Col, Card} from "react-bootstrap";

import {UserForm} from "../../modules/UserForm";

export function AccountContainer() {
  return (
    <Row>
      <Col md={{span: 8, offset: 2}}>
        <Card>
          <Card.Body>
            <UserForm />
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}
